import { type KeyboardShortcutId, type KeyboardShortcutsUnsubscribeFn, Plugins } from '@getgo/container-client'
import { type InternalNavigationLink } from '../../packages/navigation/types'
import { openNewTabFor } from '../../common/dom-helpers'
import { navigateToUrl } from '../../common/helpers'

export class NavigationKeyboardShortcutService {
  private subscriptions: Array<KeyboardShortcutsUnsubscribeFn> = []

  /**
   * Subscribe each visible link in the navigation to a Keyboard shortcut by index
   * container-client have navigation1 to navigation9 keyboardShortcuts ids to subscribe to
   */
  subscribeToVisibleLinks(links: InternalNavigationLink[]) {
    this.unsubscribeFromVisibleLinks().then(() => {
      links.map(async (link, index) => {
        const navigationIndex = index + 1
        // The maximum number of navigation subscribe in container is 9 (1 to 9)
        if (navigationIndex <= 9) {
          const keyboardShortcutId = `navigation${navigationIndex}` as KeyboardShortcutId

          Plugins.KeyboardShortcuts.subscribe(keyboardShortcutId, window, () => {
            if (link.externalLink) {
              openNewTabFor(link.href)
            } else {
              navigateToUrl(link.href)
            }
          })
            .then(unsubscribeFn => {
              this.subscriptions.push(unsubscribeFn)
            })
            .catch(error => {
              console.error('Failed to subscribe to keyboard shortcut', error)
            })
        }
      })
    })
  }

  private async unsubscribeFromVisibleLinks() {
    for (const unsubscribeFn of this.subscriptions) {
      await unsubscribeFn()
    }
    this.subscriptions = []
  }
}
